import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CardModule } from 'primeng/card';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';

import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-choose-your-excess',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    RadioButtonModule,
    FormsModule,
    OverlayPanelModule,
    ButtonModule,
    CalendarModule,
    TooltipModule,
  ],
  templateUrl: './choose-your-excess.component.html',
  styleUrl: './choose-your-excess.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChooseYourExcessComponent implements OnChanges {
  @Input() quoteEnquiry: any;
  @Output() optionChange = new EventEmitter<string>();
  @Input() selectedCover: any;
  selectedExcessValue: string = '';
  selectedExcessLabel: string = '$0';

  isTooltipVisible: boolean = false;
  isTooltipVisibleExcess: boolean = false;

  constructor() {}

  ngOnChanges() {
    if (this.selectedCover) {
      if (this.selectedCover?.selectedPrice?.excess) {
        this.selectedExcessLabel = this.selectedCover?.selectedPrice?.excess;
      }
    }
  }

  ngOnInit() {
    this.updateTooltipVisibility();
  }

  onRadioExcessClick(event: any, label: string) {
    this.selectedExcessLabel = label;
    const data: any = {
      optionName: 'excess',
      excess: label,
      isCruise: this.selectedCover?.selectedPrice?.isCruise,
      isSki: this.selectedCover?.selectedPrice?.isSki
        ? this.selectedCover?.selectedPrice?.isSki
        : false,
      isSelectedProduct: this.selectedCover?.selectedPrice?.productAlias
    };
    this.optionChange.emit(data);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateTooltipVisibility();
  }

  toggleTooltip() {
    this.isTooltipVisible = !this.isTooltipVisible;
  }

  private updateTooltipVisibility() {
    this.isTooltipVisible = window.innerWidth < 768;
    this.isTooltipVisibleExcess = window.innerWidth < 768;
  }
}
